export const RULE_GROUP_KEY = 'ruleGroup';

// rules in a group are ANDed, groups are ORed; groups come back in group-number order
export function groupRules<T>(rules: T[] = [], groupOf: (rule: T) => number): T[][] {
  const groups = new Map<number, T[]>();
  rules.forEach((rule) => {
    const group = groupOf(rule);
    groups.set(group, [...(groups.get(group) ?? []), rule]);
  });
  return [...groups.keys()].sort((a, b) => a - b).map((group) => groups.get(group));
}

// { ruleGroup1: ['rule as a sentence', ...] }: each rule gets its own line under "Rule group N"
export function toRuleGroups<T>(
  rules: T[],
  groupOf: (rule: T) => number,
  describe: (rule: T) => string,
): Record<string, string[]> {
  return Object.fromEntries(
    groupRules(rules, groupOf).map((group, index) => [`${RULE_GROUP_KEY}${index + 1}`, group.map(describe)]),
  );
}

// 'ruleGroup2' → 1
export function ruleGroupPosition(groupKey: string): number {
  return Number(groupKey?.replace(RULE_GROUP_KEY, '')) - 1;
}
